import React from 'react';

import { getPaginationItems, getPaginationKey } from './utils/PaginationItemsGenerator';
import { PaginationItem } from './PaginationItem';
import type { PaginationProps } from './Pagination';

export const PaginationBody: React.FC<PaginationProps> = ({ pagesCount, selectedPage, onPageChange }) => {
  if (!pagesCount) {
    return null;
  }

  const paginationItems = getPaginationItems(pagesCount, selectedPage);

  return (
    <>
      {paginationItems.map((item, idx) => (
        <PaginationItem
          key={getPaginationKey(item, idx)}
          item={item}
          selected={item === selectedPage}
          // @ts-expect-error: TODO fix strictFunctionTypes
          onClick={onPageChange}
        />
      ))}
    </>
  );
};
